import React from 'react';
import { Row, Col } from 'react-bs-grid';

export default ({ children }) => (
  <Row>
    <Col xs={12}>
      <h1 className="title">{children}</h1>
    </Col>
  </Row>
);



// WEBPACK FOOTER //
// ./src/components/Title.js